// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"281":"alias","596":"404","760":"card","818":"auth","963":"send"}[chunkId] + "-legacy." + {"281":"f34b867e","596":"ffae890e","760":"66dd0026","818":"cebb89fd","963":"b357b7b7"}[chunkId] + ".js";
};